// extracted by mini-css-extract-plugin
module.exports = {"questions":"SupportQuestionList_questions__2w7-G"};